import React from "react"

import ModalV4 from "../../ui/modal/v4/v4"
import QuickSearch_Main from "./main"

export default class ModalQuickSearch extends ModalV4 {

    render() {
        return <QuickSearch_Main className     = "v4-container placement-middle"
                                 onClick       = {this.stopPropagation}
                                 onCloseModal  = {this.closeModal}/>;
    }

}